{
  "version": 1,
  "asset_id": "33949d31-7299-4941-9adf-086fa4d61498",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/33949d31-7299-4941-9adf-086fa4d61498/thumb-camara-obscura.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/33949d31-7299-4941-9adf-086fa4d61498/thumb-camara-obscura.webp",
  "original_filename": "thumb-camara-obscura.webp",
  "size": 32572,
  "content_type": "image/webp",
  "created_at": "2026-10-28T12:00:29Z"
}
